import {
  Box, SimpleGrid, Stack, HStack, Skeleton, SkeletonCircle, SkeletonText, Wrap, WrapItem,
} from "@chakra-ui/react";

const card = {
  bg: "bg.card",
  border: "1px solid",
  borderColor: "border.card",
  borderRadius: "xl",
  p: 6,
};

export function StatsSkeleton() {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={6}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Box key={i} {...card}>
          <Skeleton w={10} h={10} borderRadius="lg" mb={4} />
          <Skeleton h={6} w="40%" mb={2} />
          <Skeleton h={4} w="70%" mb={1} />
          <Skeleton h={3} w="50%" />
        </Box>
      ))}
    </SimpleGrid>
  );
}

export function ListCardsSkeleton({ count = 3 }) {
  return (
    <Stack spacing={4}>
      {Array.from({ length: count }).map((_, i) => (
        <Box key={i} {...card} borderLeft="4px solid" borderLeftColor="border.card">
          <HStack spacing={3} mb={3} align="center">
            <SkeletonCircle size="11" />
            <Box flex="1">
              <Skeleton h={5} w="50%" mb={2} />
              <Skeleton h={3} w="30%" />
            </Box>
          </HStack>
          <SkeletonText noOfLines={2} spacing={2} />
        </Box>
      ))}
    </Stack>
  );
}

export function GridCardsSkeleton({ count = 6, columns = { base: 1, md: 2, lg: 3 }, image = true }) {
  return (
    <SimpleGrid columns={columns} spacing={6}>
      {Array.from({ length: count }).map((_, i) => (
        <Box key={i} {...card} p={0} overflow="hidden">
          {image && <Skeleton h="200px" />}
          <Box p={6}>
            <Skeleton h={5} w="60%" mb={3} />
            <SkeletonText noOfLines={2} spacing={2} mb={4} />
            <Wrap spacing={2}>
              <WrapItem><Skeleton h={5} w="60px" borderRadius="full" /></WrapItem>
              <WrapItem><Skeleton h={5} w="50px" borderRadius="full" /></WrapItem>
            </Wrap>
          </Box>
        </Box>
      ))}
    </SimpleGrid>
  );
}

export function CertSkeleton({ count = 6 }) {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={4}>
      {Array.from({ length: count }).map((_, i) => (
        <HStack key={i} {...card} p={4} spacing={4}>
          <SkeletonCircle size="12" />
          <Box flex="1">
            <Skeleton h={4} w="70%" mb={2} />
            <Skeleton h={3} w="40%" />
          </Box>
        </HStack>
      ))}
    </SimpleGrid>
  );
}

export function ChipsSkeleton({ count = 10 }) {
  return (
    <Box mb={8}>
      <Skeleton h={4} w="120px" mb={3} />
      <Wrap spacing={3}>
        {Array.from({ length: count }).map((_, i) => (
          <WrapItem key={i}>
            <Skeleton h={9} w="110px" borderRadius="full" />
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  );
}

export function HeroSkeleton() {
  return (
    <Box as="section" id="hero" pt={{ base: 28, md: 36 }} pb={{ base: 12, md: 20 }}>
      <Box maxW="6xl" mx="auto" px={4}>
        <Stack direction={{ base: "column", md: "row" }} spacing={12} align="center">
          <Stack flex="1" spacing={5} w="100%">
            <Skeleton h={6} w="120px" borderRadius="full" />
            <Skeleton h={12} w="80%" />
            <Skeleton h={10} w="60%" />
            <HStack spacing={4} pt={2}>
              <Skeleton h={10} w="150px" borderRadius="md" />
              <Skeleton h={10} w="130px" borderRadius="md" />
            </HStack>
            <HStack spacing={3}>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonCircle key={i} size="10" />
              ))}
            </HStack>
          </Stack>
          <Skeleton flex="1" h="340px" w="100%" maxW="sm" borderRadius="2xl" />
        </Stack>
      </Box>
    </Box>
  );
}
